'use client'

import { useCountAnimation } from '@/hooks/use-scroll-animation'
import { useI18n } from '@/components/i18n-provider'

export function StatsSection() {
  const { t } = useI18n()
  const { elementRef: accuracyRef, count: accuracyCount } = useCountAnimation(95, 1600)
  const { elementRef: cropsRef, count: cropsCount } = useCountAnimation(75, 2000)
  const { elementRef: regionsRef, count: regionsCount } = useCountAnimation(12, 1200)

  const stats = [
    { value: `${accuracyCount}%`, label: t('stats.accuracy'), ref: accuracyRef },
    { value: `${cropsCount}+`, label: t('stats.crops'), ref: cropsRef },
    { value: regionsCount.toString(), label: t('stats.regions'), ref: regionsRef },
    { value: '24/7', label: t('stats.realtime'), ref: null },
  ]

  return (
    <section className="bg-background py-16 sm:py-20">
      <div className="container grid grid-cols-2 gap-y-10 sm:grid-cols-4">
        {stats.map((stat, i) => (
          <div key={i} className="flex flex-col items-center gap-2 text-center">
            <div
              ref={stat.ref as any}
              className="tabular text-4xl font-semibold tracking-[-0.02em] text-foreground sm:text-5xl"
            >
              {stat.value}
            </div>
            <div className="text-sm text-muted-foreground">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  )
}
